// extracted by mini-css-extract-plugin
module.exports = {"CardBlock":"A0dtJ","CardBlock__Single":"tXw87","CardBlock__Slider":"uxcgC","CardBlock__Card":"_0dDss"};